import React from 'react';
import PropTypes from 'prop-types';

import SidePanelContainer from '../../common2/side-panel/SidePanelContainer';
import SidePanelContent from '../../common2/side-panel/SidePanelContent';
import SidePanelFooter from '../../common2/side-panel/SidePanelFooter';
import Column from '../../common/layout/Column';
import Message from '../../common2/Message';
import TakeActionPanelHeading from './TakeActionPanelHeading';
import DeclinedDateSection from './DeclinedDateSection';
import DeclinedReasonSection from './DeclinedReasonSection';
import Locale from '../../Translate/Locale';
import SidePanelContentSection from '../../common2/side-panel/SidePanelContentSection';
import ExternalLink from '../../common2/links/ExternalLink';
import TakeActionDocuments from './TakeActionDocuments';

function DisputeDeclinedReasonPanel(props) {
  const { claim, onClose, customerResponse } = props;
  const { isDeclinedPastTakeActionDeadline, submittedAt } = claim;

  const declinedText = isDeclinedPastTakeActionDeadline
    ? 'CLAIM_DECLINED_PAST_TAKE_ACTION_DEADLINE'
    : 'CLAIM_DECLINED_TOO_LATE_TO_DISPUTE';

  const hasFiles = customerResponse?.files?.length > 0;

  return (
    <SidePanelContainer>
      <TakeActionPanelHeading onClose={onClose}>Declined</TakeActionPanelHeading>
      <SidePanelContent>
        <Column spacing="medium">
          <DeclinedDateSection rejectedAt={claim.rejectedAt} />
          <DeclinedReasonSection customerResponse={customerResponse} />
          {submittedAt && (
            <SidePanelContentSection heading="Days remaining to Dispute">
              <Message intent="danger">
                <Locale>{declinedText}</Locale>
              </Message>
            </SidePanelContentSection>
          )}
          {hasFiles && <TakeActionDocuments customerResponse={customerResponse} />}
        </Column>
      </SidePanelContent>
      <SidePanelFooter />
    </SidePanelContainer>
  );
}

DisputeDeclinedReasonPanel.propTypes = {
  claim: PropTypes.shape({
    rejectedAt: PropTypes.string,
  }),
  customerResponse: PropTypes.object,
  onClose: PropTypes.func,
};

export default React.memo(DisputeDeclinedReasonPanel);
